import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_2fcf43b1 from 'nuxt_plugin_plugin_2fcf43b1' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_232473d9 from 'nuxt_plugin_plugin_232473d9' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_distplugin2aa1da60_0ee3fa30 from 'nuxt_plugin_distplugin2aa1da60_0ee3fa30' // Source: ./dist.plugin.2aa1da60.js (mode: 'client')
import nuxt_plugin_moduleplugin7d6e1fee_2ff9deb2 from 'nuxt_plugin_moduleplugin7d6e1fee_2ff9deb2' // Source: ./module.plugin.7d6e1fee.js (mode: 'all')
import nuxt_plugin_axios_2c7cb047 from 'nuxt_plugin_axios_2c7cb047' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_recaptcha_15d9c336 from 'nuxt_plugin_recaptcha_15d9c336' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_markdownit_547c1e97 from 'nuxt_plugin_markdownit_547c1e97' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_gtm_6aaa4646 from 'nuxt_plugin_gtm_6aaa4646' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_components_6fb0430c from 'nuxt_plugin_components_6fb0430c' // Source: ../../../plugins/components (mode: 'all')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../../../plugins/filters (mode: 'all')
import nuxt_plugin_vuejsmodal_f50827f4 from 'nuxt_plugin_vuejsmodal_f50827f4' // Source: ../../../plugins/vue-js-modal (mode: 'all')
import nuxt_plugin_lottieplayer_349b9b80 from 'nuxt_plugin_lottieplayer_349b9b80' // Source: ../../../plugins/lottie-player.client (mode: 'client')
import nuxt_plugin_vueobservevisibility_2d7eef00 from 'nuxt_plugin_vueobservevisibility_2d7eef00' // Source: ../../../plugins/vue-observe-visibility (mode: 'all')
import nuxt_plugin_richtextrenderer_22939428 from 'nuxt_plugin_richtextrenderer_22939428' // Source: ../../../plugins/rich-text-renderer (mode: 'all')
import nuxt_plugin_headroom_9eb8b79e from 'nuxt_plugin_headroom_9eb8b79e' // Source: ../../../plugins/headroom (mode: 'all')
import nuxt_plugin_googleoptimize_5a986f6c from 'nuxt_plugin_googleoptimize_5a986f6c' // Source: ./google-optimize.js (mode: 'all')
import nuxt_plugin_meta_e1cd1daa from 'nuxt_plugin_meta_e1cd1daa' // Source: ./composition-api/meta.mjs (mode: 'all')
import nuxt_plugin_integrationsanimaapiclient048dcdf0_636d76d8 from 'nuxt_plugin_integrationsanimaapiclient048dcdf0_636d76d8' // Source: ./integrations.animaapi.client.048dcdf0.js (mode: 'client')
import nuxt_plugin_integrationscalendlyclient91307410_68eb280e from 'nuxt_plugin_integrationscalendlyclient91307410_68eb280e' // Source: ./integrations.calendly.client.91307410.js (mode: 'client')
import nuxt_plugin_integrationshubspotclient3d162495_67bd1440 from 'nuxt_plugin_integrationshubspotclient3d162495_67bd1440' // Source: ./integrations.hubspot.client.3d162495.js (mode: 'client')
import nuxt_plugin_integrationss3client9625b004_f6015732 from 'nuxt_plugin_integrationss3client9625b004_f6015732' // Source: ./integrations.s3.client.9625b004.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Anima | Design to code | High-fidelity prototypes | Designer-developer collaboration","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Anima gives you the power to create fully interactive prototypes using Figma, XD, and Sketch & transform these designs to developer-friendly React and HTML code automatically."},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fanimaapp.s3.amazonaws.com\u002Fimg\u002Fwebsite-cover.png"},{"hid":"twitter:image:src","name":"twitter:image:src","content":"https:\u002F\u002Fanimaapp.s3.amazonaws.com\u002Fimg\u002Fwebsite-cover.png"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fs3.amazonaws.com\u002Fprojects4.animaapp.com\u002Ffavicon.ico"},{"rel":"preconnect","href":"\u002F\u002Fimg2.storyblok.com"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@stigg\u002Fembed-sdk@1.6.0\u002Fdist\u002Fembed-sdk.min.css"},{"hid":"gf-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"gf-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"gf-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Roboto&family=Caveat:wght@700&family=Mulish:wght@400;800&display=swap"}],"script":[{"src":"https:\u002F\u002Fwww.googleoptimize.com\u002Foptimize.js?id=OPT-52RD5WG"},{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@stigg\u002Fembed-sdk@4.3.0\u002Fdist\u002Fembed-sdk.min.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-5GH35Q5')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"},{"hid":"gf-script","innerHTML":"(function(){var l=document.createElement('link');l.rel=\"stylesheet\";l.href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Roboto&family=Caveat:wght@700&family=Mulish:wght@400;800&display=swap\";document.querySelector(\"head\").appendChild(l);})();"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-5GH35Q5&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"},{"hid":"gf-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Roboto&family=Caveat:wght@700&family=Mulish:wght@400;800&display=swap\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"],"gf-script":["innerHTML"],"gf-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_2fcf43b1 === 'function') {
    await nuxt_plugin_plugin_2fcf43b1(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_232473d9 === 'function') {
    await nuxt_plugin_plugin_232473d9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_distplugin2aa1da60_0ee3fa30 === 'function') {
    await nuxt_plugin_distplugin2aa1da60_0ee3fa30(app.context, inject)
  }

  if (typeof nuxt_plugin_moduleplugin7d6e1fee_2ff9deb2 === 'function') {
    await nuxt_plugin_moduleplugin7d6e1fee_2ff9deb2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2c7cb047 === 'function') {
    await nuxt_plugin_axios_2c7cb047(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_15d9c336 === 'function') {
    await nuxt_plugin_recaptcha_15d9c336(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_547c1e97 === 'function') {
    await nuxt_plugin_markdownit_547c1e97(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_6aaa4646 === 'function') {
    await nuxt_plugin_gtm_6aaa4646(app.context, inject)
  }

  if (typeof nuxt_plugin_components_6fb0430c === 'function') {
    await nuxt_plugin_components_6fb0430c(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejsmodal_f50827f4 === 'function') {
    await nuxt_plugin_vuejsmodal_f50827f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lottieplayer_349b9b80 === 'function') {
    await nuxt_plugin_lottieplayer_349b9b80(app.context, inject)
  }

  if (typeof nuxt_plugin_vueobservevisibility_2d7eef00 === 'function') {
    await nuxt_plugin_vueobservevisibility_2d7eef00(app.context, inject)
  }

  if (typeof nuxt_plugin_richtextrenderer_22939428 === 'function') {
    await nuxt_plugin_richtextrenderer_22939428(app.context, inject)
  }

  if (typeof nuxt_plugin_headroom_9eb8b79e === 'function') {
    await nuxt_plugin_headroom_9eb8b79e(app.context, inject)
  }

  if (typeof nuxt_plugin_googleoptimize_5a986f6c === 'function') {
    await nuxt_plugin_googleoptimize_5a986f6c(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_e1cd1daa === 'function') {
    await nuxt_plugin_meta_e1cd1daa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsanimaapiclient048dcdf0_636d76d8 === 'function') {
    await nuxt_plugin_integrationsanimaapiclient048dcdf0_636d76d8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationscalendlyclient91307410_68eb280e === 'function') {
    await nuxt_plugin_integrationscalendlyclient91307410_68eb280e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationshubspotclient3d162495_67bd1440 === 'function') {
    await nuxt_plugin_integrationshubspotclient3d162495_67bd1440(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationss3client9625b004_f6015732 === 'function') {
    await nuxt_plugin_integrationss3client9625b004_f6015732(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
